import * as React from "react"
import {Grid, Skeleton} from "@mui/material";
import {generateArrayByNumber} from "@ui-seeker/utils";


export default function PriceEvolutionWidgetLoadingBlock() {
	return <Grid container spacing={2}>
		{ generateArrayByNumber(12).map(idx => <Grid item xs={3} key={idx}>
			<Skeleton variant="rectangular" height={90}/>
		</Grid>) }
	</Grid>
}